module.exports = __webpack_public_path__ + "img/logo11.c8d068ce.png";